import { render, staticRenderFns } from "./propertyDetails.vue?vue&type=template&id=1756f670"
import script from "./propertyDetails.ts?vue&type=script&lang=js&external"
export * from "./propertyDetails.ts?vue&type=script&lang=js&external"
import style0 from "./propertyDetails.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports